import actions from '../../actionTypes';

export default (areaId, zones) => {
  return {
    type: actions.SET_ZONES,
    areaId,
    zones
  };
};



// WEBPACK FOOTER //
// ./src/reducers/zones/actions/setZones.js